import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Account } from '../models/account';
import { environment } from '../../environments/environment';
import { Asset } from '../models/asset';
import { Me } from '../models/me';
import { AlertSettings } from '../models/alertsettings';
import { CustomStat } from '../models/customstat';
import { Instance } from '../models/instance';
import { Template } from '../models/template';
import { TemplateType } from '../models/templatetype';
import { Version } from '../models/version';

@Injectable({ providedIn: 'root' })
export class NostosService {

  private apiURL: string = "";

  constructor(private http: HttpClient) { }

  getAPI(): string {

    console.log("API URL: " + environment.apiUrl);
    if (this.apiURL.length == 0) {
      return environment.apiUrl;
    }
    if (this.apiURL.indexOf("localhost") >= 0) {
      return "http://" + this.apiURL + "/api";
    }
    return "https://" + this.apiURL + "/api";

  }

  getChartsUrl(hostid: string): string {

    const url = new URL(`${environment.zabbixUrl}/zabbix.php`);

    url.search = new URLSearchParams({
      from: "now-1h",
      to: "now",
      action: "charts.view",
      "filter_hostids[]": `${hostid}`,
      filter_name: "",
      filter_show: "2",
      filter_set: "1"
    }).toString();

    return url.href;

  }

  getProblemsUrl(hostid: string): string {

    const url = new URL(`${environment.zabbixUrl}/zabbix.php`);

    url.search = new URLSearchParams({
      show: "1",
      name: "",
      acknowledgement_status: "0",
      "inventory[0][field]": "type",
      "inventory[0][value]": "",
      evaltype: "0",
      "tags[0][tag]": "",
      "tags[0][operator]": "0",
      "tags[0][value]": "",
      show_tags: "3",
      tag_name_format: "0",
      tag_priority: "",
      show_opdata: "0",
      show_timeline: "1",
      filter_name: "",
      filter_show_counter: "0",
      filter_custom_time: "0",
      sort: "clock",
      sortorder: "DESC",
      age_state: "0",
      show_symptoms: "0",
      show_suppressed: "0",
      acknowledged_by_me: "0",
      compact_view: "0",
      details: "0",
      highlight_row: "0",
      action: "problem.view",
      "hostids[]": `${hostid}`
    }).toString();

    return url.href;

  }

  getDownloadsUrl(): string {

    console.log("Downloads URL: " + environment.downloadsUrl);
    return environment.downloadsUrl;

  }

  searchAccounts(searchTerm: string): Observable<Account[]> {

    console.log("searchAccounts invoked");
    const params = new HttpParams().set('q', searchTerm);
    return this.http.get<Account[]>(`${this.getAPI()}/accounts/search`, { params });

  }

  getAssetsForAccount(accountId: string): Observable<Asset[]> {

    console.log("getAssetsForAccount invoked");
    return this.http.get<Asset[]>(`${this.getAPI()}/accounts/${accountId}/assets`);

  }

  getAssetZip(assetId: string): Observable<HttpResponse<Blob>> {
    const url = `${this.getAPI()}/assets/${assetId}/zip`;
    return this.http.get(url, { observe: 'response', responseType: 'blob' });
  }

  getMe(): Observable<Me> {

    console.log("getAssetsForAccount invoked");
    return this.http.get<Me>(`${this.getAPI()}/me`);

  }

  createMonitor(assetId: string): Observable<Asset> {

    const url = `${this.getAPI()}/assets/${assetId}/monitor`;
    return this.http.post<Asset>(url, null);

  }

  deleteMonitor(assetId: string): Observable<void> {

    const url = `${this.getAPI()}/assets/${assetId}/monitor`;
    return this.http.delete<void>(url);

  }

  setAlerts(assetId: string, settings: AlertSettings): Observable<AlertSettings> {

    console.log("postAlertSettings invoked");
    return this.http.post<AlertSettings>(`${this.getAPI()}/assets/${assetId}/monitor/alerts`, settings);

  }

  getAlerts(assetId: string): Observable<AlertSettings> {

    return this.http.get<AlertSettings>(`${this.getAPI()}/assets/${assetId}/monitor/alerts`);

  }

  getCustomStats(assetId: string): Observable<CustomStat[]> {

    return this.http.get<CustomStat[]>(`${this.getAPI()}/assets/${assetId}/monitor/custom`);

  }

  getInstances(): Observable<Instance[]> {

    return this.http.get<Instance[]>(`${this.getAPI()}/instances`);

  }

  getTemplateTypes(): Observable<TemplateType[]> {

    return this.http.get<TemplateType[]>(`${this.getAPI()}/templatetypes`);

  }

  getTemplates(): Observable<Template[]> {

    return this.http.get<Template[]>(`${this.getAPI()}/templates`);

  }

  addTemplate(template: Template): Observable<Template> {

    console.log("addTemplate invoked");
    return this.http.post<Template>(`${this.getAPI()}/templates`, template);

  }

  updateTemplate(template: Template): Observable<Template> {

    console.log("updateTemplate invoked");
    return this.http.put<Template>(`${this.getAPI()}/templates`, template);

  }

  deleteTemplate(templateId: string): Observable<void> {

    const url = `${this.getAPI()}/templates/${templateId}`;
    return this.http.delete<void>(url);

  }

   getVersion(): Observable<Version> {

    return this.http.get<Version>(`${this.getAPI()}/version`);

  }

}
